<header>
	<div>
		<a
			id="logoHome"
			href="#home"
			title="Ir a la página principal de Ecoturismo BASE"
		>
			<img
				src="./logos/ecoturismo-base.svg"
				alt="Logo Ecoturismo BASE"
				class="logo"
			/>
		</a>
		<nav>
			<ul>
				<!-- <li><a href="#home">Home</a></li> -->
				<li><a href="#tiny-house">Tiny House</a></li>
				<!-- <li><a href="a">Lugares de Interés</a></li> -->
				<li><a href="#nosotros">Nosotros</a></li>
				<li><a href="#como-llegar">¿Cómo Llegar?</a></li>
				<!-- <li><a href="a">Contacto</a></li> -->
			</ul>
		</nav>
	</div>
</header>

<style lang="scss">
	#logoHome {
		height: 100%;
		img.logo {
			//height: 90px;
			//width: auto;
			height: 100%;
		}
	}

	header {
		// background: url(/img/bg-menu.svg);
		// background-size: contain;
		// background-repeat: repeat-x;
		background: #fff;
		position: fixed;
		top: 0;
		width: 100%;
		z-index: 999;
		> div {
			height: 75px;
			padding: 1rem;
			display: flex;
			align-items: center;
			max-width: 1140px;
			margin: 0 auto;
			justify-content: space-between;
		}
	}

	nav > ul {
		display: flex;
		a {
			padding: 1rem;
			color: #3c342b;
			&:hover {
				text-decoration: none;
				color: green;
			}
		}
	}

	ul,
	li {
		list-style-type: none;
		margin: 0;
		padding: 0;
	}
	li > a {
		text-transform: uppercase;
	}
</style>
